import React from "react";
import classnames from "classnames";
import { Form, Row, Col } from "react-bootstrap";
import { FiStar } from "react-icons/fi";
import { formatCurrency } from "utils/number";
import { DAILY, PER_PAY_PERIOD } from "utils/timeHelper";

const modifierToAbbrvModifierMap: Record<string, string> = {
  [DAILY]: "daily",
  TWICE_PER_MONTH: "twice a month",
  WEEKLY: "weekly",
  EVERY_OTHER_WEEK: "every two weeks",
  MONTHLY: "monthly",
};

interface ContributionLimits {
  min?: number;
  max?: number;
}

interface Props {
  onSelect?: (amount?: number) => void;
  setCustomAmount?: (amount: number) => void;
  isSelected?: boolean;
  isCustomAmount?: boolean;
  isRecommended?: boolean;
  amount?: number;
  modifier?: string;
  payperiod?: string;
  customAmountError?: string;
  customAmountDisplayValue?: string;
  contributionLimits?: ContributionLimits;
}

const SelectContributionBox = ({
  onSelect,
  isSelected,
  isCustomAmount,
  isRecommended,
  amount,
  modifier,
  customAmountError,
  setCustomAmount,
  contributionLimits,
}: Props) => {
  const modifierDisplayVal = modifierToAbbrvModifierMap[modifier!];

  return (
    <Row>
      <Col>
        <div
          className={classnames("select-contribution-box", {
            selected: isSelected,
            recommended: isRecommended,
            custom: isCustomAmount,
            error: !!customAmountError,
          })}
          onClick={() => onSelect!(amount)}
        >
          {!isCustomAmount && (
            <div className="contribution-amount-container">
              <span className="amount">{formatCurrency(amount!)}</span>
              <span className="amount-modifier">{modifierDisplayVal}</span>
            </div>
          )}
          {isRecommended && (
            <div className="recommended-container">
              <FiStar size={12} color="#FFFFFF" /> Most popular
            </div>
          )}
          {isCustomAmount && (
            <div className="contribution-custom-amount-container">
              {!isSelected && (
                <span className="custom-amt-msg">Enter custom amount</span>
              )}
              {isSelected && (
                <>
                  <span className="dollar">$</span>
                  <Form.Control
                    style={{
                      width: 105,
                      display: "inline-block",
                      marginRight: 8,
                      marginLeft: 3,
                      paddingLeft: "1rem",
                    }}
                    name="incomeLimitsRawValue"
                    size="sm"
                    // @ts-expect-error placeholder is typed string but a number is passed (stringified at runtime); preserving original behavior
                    placeholder={modifier === PER_PAY_PERIOD ? 25 : 1} // variant based on monthly/daily
                    // @ts-expect-error value is typed string | number but null is passed; preserving original behavior
                    value={amount === 0 ? null : amount}
                    type="number"
                    max={contributionLimits!.max}
                    min={contributionLimits!.min}
                    onChange={(e) => {
                      let amount = +e.target.value;
                      setCustomAmount!(amount);
                    }}
                    isInvalid={!!customAmountError}
                    // @ts-expect-error isValid is typed boolean but the original expression yields number | boolean | undefined; preserving original behavior
                    isValid={amount && !customAmountError}
                  />
                  <span
                    style={{
                      verticalAlign: "bottom",
                      color: "#70747d",
                      fontSize: 14,
                    }}
                  >
                    {modifierDisplayVal}
                  </span>
                  <Form.Control.Feedback type="invalid">
                    {customAmountError}
                  </Form.Control.Feedback>
                </>
              )}
            </div>
          )}

          {isCustomAmount && isSelected && (
            <div className="description">
              <ul>
                <li>
                  Minimum contribution is{" "}
                  {formatCurrency(contributionLimits!.min!, 0)}
                </li>
                <li>
                  Maximum contribution is{" "}
                  {formatCurrency(contributionLimits!.max!)}
                </li>
              </ul>
            </div>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default SelectContributionBox;
